/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoicePaymentsListEdit: "invoice-payments-list-edit",
  invoicePaymentsListDelete: "invoice-payments-list-delete",
} as const;
